import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { ArrowRight } from "lucide-react";
import TransitionLink from "@/components/TransitionLink";
import { cn } from "@/lib/utils";

export const ctaVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap transition-colors outline-none focus-visible:ring-3 focus-visible:ring-brand/50 disabled:pointer-events-none disabled:opacity-60",
  {
    variants: {
      variant: {
        navy: "bg-navy text-white hover:bg-navy-hover",
        brand: "bg-brand text-navy hover:bg-brand-hover",
      },
      size: {
        sm: "h-11 px-6 text-sm",
        md: "h-12 px-7 text-[15px]",
      },
    },
    defaultVariants: {
      variant: "navy",
      size: "md",
    },
  },
);

interface CtaLinkProps extends VariantProps<typeof ctaVariants> {
  to: string;
  children: React.ReactNode;
  arrow?: boolean;
  className?: string;
}

const CtaLink = ({ to, children, arrow = true, variant, size, className }: CtaLinkProps) => {
  return (
    <TransitionLink to={to} className={cn(ctaVariants({ variant, size }), className)}>
      {children}
      {arrow && <ArrowRight className="size-4" aria-hidden />}
    </TransitionLink>
  );
};

export default CtaLink;
